import type { Params } from 'vue3-ts-jsoneditor'
import './json-editor.css'

export { JsonEditorPlugin as default } from 'vue3-ts-jsoneditor'

export const jsonEditorConfig = {} satisfies Params
